module.exports = __webpack_public_path__ + "img/unauthorized.9df1b986.svg";